import React, { useEffect, useState } from 'react';
import { Image as ImageIcon } from 'lucide-react';

const SHIMMER_STYLE_ID = 'loading-image-shimmer-keyframes';

const LoadingImage = ({
  src,
  alt,
  className = '',
  imgClassName = '',
  containerClassName = '',
  skeletonClassName = '',
  fallback = null,
  onClick,
  ...imgProps
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setIsLoaded(false);
    setHasError(false);
  }, [src]);

  useEffect(() => {
    if (typeof document === 'undefined') return;
    if (document.getElementById(SHIMMER_STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = SHIMMER_STYLE_ID;
    style.textContent = `
      @keyframes loadingImageShimmer {
        0% { background-position: 200% 0; }
        100% { background-position: -200% 0; }
      }
    `;
    document.head.appendChild(style);
  }, []);

  const showFallback = !src || hasError;
  const showSkeleton = Boolean(src) && !isLoaded && !hasError;

  return (
    <div className={`relative overflow-hidden ${containerClassName}`}>
      {showSkeleton && (
        <div
          className={`absolute inset-0 ${skeletonClassName}`}
          style={{
            backgroundImage: 'linear-gradient(90deg, #e5e7eb 25%, #f3f4f6 45%, #e5e7eb 65%)',
            backgroundSize: '200% 100%',
            animation: 'loadingImageShimmer 1.2s linear infinite',
          }}
        />
      )}

      {!showFallback && (
        <img
          src={src}
          alt={alt}
          className={`${className} ${imgClassName} ${isLoaded ? 'opacity-100' : 'opacity-0'} transition-opacity duration-200`}
          onLoad={() => setIsLoaded(true)}
          onError={() => setHasError(true)}
          onClick={onClick}
          {...imgProps}
        />
      )}

      {showFallback && (
        fallback || (
          <div className={`w-full h-full flex items-center justify-center bg-gray-100 ${className}`}>
            <ImageIcon className="text-gray-300" size={24} />
          </div>
        )
      )}
    </div>
  );
};

export default LoadingImage;
